import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import BoxShadow from "../../../shared/BoxShadow/BoxShadow";
import SuccessStoriesHeader from "../../../components/AdminPanel/SuccessStories/SuccessStoriesHeader";
import SuccessStoriesTable from "../../../components/AdminPanel/SuccessStories/SuccessStoriesTable";

const SuccessStories = () => {
  return (
    <AdminPanelLayout>
      <BoxShadow>
        <div className="mt-7">
          <SuccessStoriesHeader />
          <SuccessStoriesTable />
        </div>
      </BoxShadow>
    </AdminPanelLayout>
  );
};

export default SuccessStories;
